import { blue, ColorScale, green, red, yellow } from 'bold-ui/lib/styles/colors'
import { CidSelectFieldModel } from 'components/form/field/select/CidSelectField/CidSelectField'
import { Color } from 'csstype'
import {
  ClassificacaoRiscoEncaminhamentoEnum,
  EncaminhamentosExternosEspecializadosQuery,
  EncaminhamentosExternosQuery,
  EspecialidadeSisreg,
  Period,
  TipoEncaminhamentoExternoEnum,
} from 'graphql/types.generated'
import { SoapEditableItem } from 'view/atendimentos/atendimento-individual/model'
import { RowType } from 'view/atendimentos/detail/components/EditableList'

export interface EncaminhamentoExternoEspecializadoModel extends RowType, SoapEditableItem {
  especialidadeSisreg: EspecialidadeSisreg
  classificacaoRiscoEncaminhamento: ClassificacaoRiscoEncaminhamentoEnum
  cidEncaminhamento?: CidSelectFieldModel
  observacoes?: string
  motivoEncaminhamento?: string
  complemento?: string
}
export interface EncaminhamentoExternoFilterModel {
  periodo?: Period
  somenteMeus?: boolean
  especialidade?: EspecialidadeSisregModel
  tipoEncaminhamento?: TipoEncaminhamentoExternoEnum
}

export interface EspecialidadeSisregModel {
  id: ID
  descricao: string
}

export interface EncaminhamentoExternoEspecializadoPlanoModel {
  encaminhamentosEspecializadosRecentes?: ReadonlyArray<EncaminhamentoExternoEspecializadoModel>
  encaminhamentosRecentes?: ReadonlyArray<TipoEncaminhamentoExternoEnum>
  openedAccordions?: string[]
}

export const tipoEncaminhamentoExternoEnumRecord: Record<TipoEncaminhamentoExternoEnum, { descricao: string }> = {
  [TipoEncaminhamentoExternoEnum.CAPS]: {
    descricao: 'CAPS',
  },
  [TipoEncaminhamentoExternoEnum.INTERNACAO_HOSPITALAR]: {
    descricao: 'Internação hospitalar',
  },
  [TipoEncaminhamentoExternoEnum.INTERSETORIAL]: {
    descricao: 'Intersetorial',
  },
  [TipoEncaminhamentoExternoEnum.SERVICO_ATENCAO_DOMICILIAR]: {
    descricao: 'Serviço de atenção domiciliar',
  },
  [TipoEncaminhamentoExternoEnum.URGENCIA]: {
    descricao: 'Urgência',
  },
  [TipoEncaminhamentoExternoEnum.SERVICO_ESPECIALIZADO]: {
    descricao: 'Serviço Especializado',
  },
}

export type EncaminhamentosModel = EncaminhamentosExternosEspecializadosQuery['encaminhamentosEspecializados']
export type EncaminhamentoExternoEspecializadoQueryModel = EncaminhamentosExternosEspecializadosQuery['encaminhamentosEspecializados']['content'][0]
export type EncaminhamentoExternoQueryModel = EncaminhamentosExternosQuery['encaminhamentos'][0]

export interface EncaminhamentoExternoRowModel extends SoapEditableItem {
  id: ID
  classificacaoRiscoEncaminhamento?: ClassificacaoRiscoEncaminhamentoEnum
  atendimentoProfissional: {
    id: ID
    iniciadoEm: Instant
    lotacao: { id: ID; profissional: { id: ID } }
  }
  especialidadeSisreg?: {
    id: ID
    descricao: string
  }
  hipoteseDiagnostica?: {
    id: ID
    nome: string
    codigo: string
  }
  isRegistradoAgora: boolean
  tipoEncaminhamento: TipoEncaminhamentoExternoEnum
}

export const classificacaoRiscoRecord: Record<
  ClassificacaoRiscoEncaminhamentoEnum,
  { label: string; mainColor: Color; colorScale: ColorScale }
> = {
  [ClassificacaoRiscoEncaminhamentoEnum.ELETIVO]: {
    label: 'Eletivo',
    mainColor: blue.c40,
    colorScale: blue,
  },
  [ClassificacaoRiscoEncaminhamentoEnum.PRIORITARIO]: {
    label: 'Prioritário',
    mainColor: green.c40,
    colorScale: green,
  },
  [ClassificacaoRiscoEncaminhamentoEnum.URGENCIA]: {
    label: 'Urgência',
    mainColor: yellow.c60,
    colorScale: yellow,
  },
  [ClassificacaoRiscoEncaminhamentoEnum.EMERGENCIA]: {
    label: 'Emergência',
    mainColor: red.c40,
    colorScale: red,
  },
}
